import api from '@/services/api/config';

import typ from './typ';

const path = 'v1/asset-standard/historie';

export default {
  get: (werkzeug, typParam, types, createdFrom, eigene, reparaturliste, angebotserstellung, von, bis, page, size, sort = null, desc = false) => api.get(path, {
    params: {
      werkzeug, typ: typParam, types, created_from: createdFrom, eigene, reparaturliste, angebotserstellung, von, bis, page, size, sort, desc,
    },
  }),
  typ,
};
